<afoone-breadcrumb
  [breadcrumbItems]="[
    {
      label: 'USERS.LIST_TITLE',
      route: '/users/',
    },
    {
      label: 'USERS.DETAIL',
    }
  ]"
></afoone-breadcrumb>

<div class="form-container">
  <form [formGroup]="form">
    <div class="form-row form-inline">
      <label for="txtUserName">{{ "USERS.USERNAME" | translate | requiredLabel }}</label>
      <input
        type="text"
        id="txtUserName"
        pInputText
        formControlName="userName"
        maxlength="30"
      />
      <p-toggleButton
        *ngIf="userKeycloakStatus === 'ok'"
        id="toggleEnabled"
        formControlName="enabled"
        onLabel="{{ 'USERS.ENABLED' | translate }}"
        offLabel="{{ 'USERS.DISABLED' | translate }}"
        (onChange)="toggleEnabled($event)"
      />
    </div>

    <div class="form-row">
      <label for="txtRole">{{ "USERS.ROLE" | translate | requiredLabel }}</label>
      <app-role-select formControlName="role"></app-role-select>
    </div>

    <div class="form-row">
      <label for="txtProfiles">{{ "USERS.PROFILES" | translate }}</label>
      <app-profile-select formControlName="profiles"></app-profile-select>
    </div>

    <div class="form-row">
      <label for="txtEmail">{{ "USERS.EMAIL" | translate | requiredLabel }}</label>
      <input type="email" id="txtEmail" pInputText formControlName="email" />
    </div>

    <div class="form-row">
      <label for="txtId">{{ "USERS.ID" | translate | requiredLabel: isIDRequired }}</label>
      <input
        type="text"
        id="txtId"
        pInputText
        formControlName="idCard"
        [maxlength]="12"
        [required]="isIDRequired"
      />
    </div>

    <!-- firstName -->
    <div class="form-row form-inline">
      <label for="txtFirstName">{{ "USERS.NAME" | translate }}</label>
      <input
        type="text"
        id="txtFirstName"
        pInputText
        formControlName="firstName"
        [maxlength]="50"
      />
      <label for="txtLastName">{{ "USERS.LASTNAME" | translate }}</label>
      <input
        type="text"
        id="txtLastName"
        pInputText
        formControlName="lastName"
        [maxlength]="100"
      />
    </div>

    <!-- password -->
    <div class="form-row form-inline">
      <!-- confirmPassword -->

      <label for="txtPassword">{{
        user
          ? ("USERS.CHANGE_PASSWORD" | translate)
          : ("USERS.NEW_PASSWORD" | translate)
      }}</label>
      <input
        type="password"
        id="txtPassword"
        pInputText
        formControlName="password"
        maxlength="50"
      />
      <!-- confirmPassword -->

      <label for="txtConfirmPassword">{{
        "USERS.CONFIRM_PASSWORD" | translate
      }}</label>
      <input
        type="password"
        id="txtConfirmPassword"
        pInputText
        formControlName="confirmPassword"
        maxlength="50"
      />
    </div>

    <afoone-sisifo-user
      *ngIf="changeServolabUser"
      formControlName="sisifoUser"
    ></afoone-sisifo-user>
  </form>

  <p-button
    label="{{ 'SAVE' | translate }}"
    (click)="saveChanges()"
    [loading]="saving"
  ></p-button>

  <!-- STATUS WITH ICONS -->
  <div class="float-status" *ngIf="!isNew">
    <div>{{ "USERS.STATUS.TITLE" | translate }}</div>
    <ul>
      {{
        "USERS.STATUS.INTERNAL" | translate
      }}:
      <i
        [ngClass]="{
          pi: true,
          'pi-spin pi-spinner': userStatus === 'loading',
          'pi-check': userStatus === 'ok',
          'pi-times': userStatus === 'not-found',
          'pi-exclamation-triangle': userStatus === 'error'
        }"
        style="font-size: 0.8rem"
      ></i>
    </ul>
    <ul>
      {{
        "USERS.STATUS.KEYCLOAK" | translate
      }}:
      <i
        [ngClass]="{
          pi: true,
          'pi-spin pi-spinner': userKeycloakStatus === 'loading',
          'pi-check': userKeycloakStatus === 'ok',
          'pi-times': userKeycloakStatus === 'not-found',
          'pi-exclamation-triangle': userKeycloakStatus === 'error'
        }"
        style="font-size: 0.8rem"
      ></i>
    </ul>

    <ul *ngIf="changeServolabUser">
      {{
        "USERS.STATUS.SERVOLAB" | translate
      }}:
      <i
        [ngClass]="{
          pi: true,
          'pi-spin pi-spinner': userServolabStatus === 'loading',
          'pi-check': userServolabStatus === 'ok',
          'pi-times': userServolabStatus === 'not-found',
          'pi-exclamation-triangle': userServolabStatus === 'error'
        }"
        style="font-size: 0.8rem"
      ></i>
    </ul>
  </div>
</div>
